<style lang="css" scope>
  .wz-comment-post {
    padding: 0.2rem;
  }
  .wz-comment-post .input-group {
      position: relative;
      display: -webkit-box;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      border-collapse: separate;
      width: 100%;
  }
  .wz-comment-post .input-group .form-control {
      flex: 1;
      padding: 10px 12px;
      color: #555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #eee;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
  }
  
  .wz-comment-post .input-group .input-group-submit {
      font-size: 0.34rem;
      padding: 10px 12px;
      font-weight: 400;
      color: #fff;
      background-color: #de3031;
      text-align: center;
      border: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      vertical-align: middle;
      width: 1.5rem;
  }
  .wz-comment-post .input-group .input-group-submit:disabled {
    background-color: #ddd;
  }
</style>
<template>
  <div class="wz-comment-post">
    <slot name="head"></slot>
    <div class="input-group">
        <input type="text" class="form-control" :placeholder="placeholder"  v-model="content" :maxlength="maxlength">
        <button class="input-group-submit" :disabled="!content" @click="submit">{{submitText}}</button>
    </div>
    <slot name="foot"></slot>
  </div>
</template>

<script>
  import {
    commentPost
  } from '../../api/g/comment'
  export default {
    name: 'wz-comment-post',
    data() {
      return {
        content: ''
      }
    },
    props: {
      objType: {type: [Number, String], default: 0},
      objId: {type: [Number, String], default: 0},
      hidden: {type: [Number, String], default: 0},
      useStar: {type: Number, default: 0},
      placeholder: {type: String, default: '请您输入内容'},
      submitText: {type: String, default: '发送'},
      maxlength: {type: Number, default: 200},
      params: {type: Object, default: null}
    },
    computed: {},
    methods: {
      async submit() {
        const {content, objType, objId, hidden, params} = this
        const query = {
          ...params,
          content, objType, objId, hidden
        }
        try {
          const R = await commentPost(query)
          this.content = ''
          this.$emit('success', R)
        } catch (error) {
          this.$emit('fail', error)
        }
      }
    },
    created() {},
    beforeDestroy() {}
  }
</script>
